"use strict";
/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
Object.defineProperty(exports, "__esModule", { value: true });
var awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://iq6dfgxrsbba3f76edp7snc5ry.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-hozqvfjj3fgchljrmerxwtodqu"
};
exports.default = awsmobile;
//# sourceMappingURL=aws-exports.js.map